<template>
  <div class="flex flex-row items-center justify-center w-full">
    <div class="max-w-[400px] w-full flex flex-row justify-between">
      <ItemTabButton
        name="Swords"
        :is-selected="activeTab == 0"
        @click="changeActiveTab(0)"
        item="sword"
      ></ItemTabButton>
      <ItemTabButton
        name="Hats"
        :is-selected="activeTab == 1"
        @click="changeActiveTab(1)"
        item="hat"
      ></ItemTabButton>
      <ItemTabButton
        name="Shirts"
        :is-selected="activeTab == 2"
        @click="changeActiveTab(2)"
        item="shirts"
      ></ItemTabButton>
      <ItemTabButton
        name="Pants"
        :is-selected="activeTab == 3"
        @click="changeActiveTab(3)"
        item="pants"
        itemWidth="sm"
      ></ItemTabButton>
      <ItemTabButton
        name="Shoes"
        :is-selected="activeTab == 4"
        @click="changeActiveTab(4)"
        item="shoes"
        item-width="sm"
      ></ItemTabButton>
      <ItemTabButton
        name="Belts"
        :is-selected="activeTab == 5"
        @click="changeActiveTab(5)"
        item="belt"
      ></ItemTabButton>
    </div>
  </div>
</template>
<script setup>
import { onMounted, ref } from 'vue'
import ItemTabButton from './ItemTabButton.vue'

const emit = defineEmits(['update:modelValue'])
const activeTab = ref(0)

const changeActiveTab = (index) => {
  activeTab.value = index
  emit('update:modelValue', index)
}

onMounted(() => {
  emit('update:modelValue', activeTab.value)
})
</script>
